import { useState } from "react";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import { getImageUrl } from "src/Common/common";
import { timecardCycleOptions } from "src/Common/contants";


function TimecardCycleDropdown({
  timecardCycle,
  timecardCycleSelected,
  isEditing = false,
  hasError = false,
}) {
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);

  const timecardCycleClicked = (cycle, e) => {
    e.stopPropagation();
    timecardCycleSelected(cycle.id);
    setIsDropDownOpen(false);
  };

  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        setIsDropDownOpen(false);
      }}
    >
      <div
        onClick={() => setIsDropDownOpen(!isDropDownOpen)}
        className={`w-full h-[30px] px-[15px] py-[5px] border-[1px] rounded-md col-span-1 flex items-center justify-between cursor-pointer relative ${
          hasError ? "border-red-500" : ""
        }`}
      >
        <span className="font-OpenSansRegular text-[11px] font-[400]">
          {timecardCycle !== null && timecardCycle !== undefined
            ? timecardCycleOptions.find((cycle) => cycle.id === timecardCycle)?.name
            : "Select Timecard Cycle"}
        </span>
        <img src={getImageUrl("/images/common/arrow-down.png")} />

        {isDropDownOpen && (
          <div className="w-full absolute px-1 py-1 border-[#E6E7EC] border-[1px] top-[32px] left-0 z-10 bg-white flex flex-col justify-between shadow-xl">
            {timecardCycleOptions.map((cycle, index) => {
              return (
                <div
                  key={cycle.id}
                  className={`w-full h-[30px] flex items-center gap-2 px-2 relative cursor-pointer hover:bg-gray-300 ${isEditing && timecardCycle === cycle.id ? "bg-gray-300" : ""
                    }`}
                  onClick={(e) => timecardCycleClicked(cycle, e)}
                >
                  <p className="font-OpenSansRegular text-[11px] text-inputEmailTitle font-[400]">{cycle.name}</p>
                  {index < timecardCycleOptions.length - 1 && (
                    <div className="w-full h-[1px] bg-gray-200 absolute left-0 right-0 bottom-0" />
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </OutsideClickHandler>
  );
}

export default TimecardCycleDropdown;
